module.exports = __webpack_public_path__ + "img/lianJ_yc.43aa23b9.svg";